import { useTranslation } from 'react-i18next';
import { Box, Button, Dialog } from '@mui/material';
import ModalCard, { ModalRow } from '../../modal/ModalCard';


interface ISaveFormChangesModalProps {
  isModalVisible: boolean;
  onSave: () => void;
  onExit: () => void;
  onClose: () => void;
}

const SaveFormChangesModal = ({ isModalVisible, onSave, onExit, onClose }: ISaveFormChangesModalProps) => {
  const { t } = useTranslation(['form', 'common']);

  return (
    <Dialog open={isModalVisible} onClose={onClose}>
      <ModalCard sx={{ borderRadius: 4, height: '100%', overflow: 'auto' }} minWidth={550} title={t('form:formChanges')} closeCallback={onClose}>
        <ModalCard.Main isDivider={false}>
          <ModalRow>{t('form:formChangesWarning')}</ModalRow>
        </ModalCard.Main>

        <ModalCard.Action>
          <Box sx={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
            <Button variant="contained" color="error" onClick={onExit}>
              {t('form:cancelFormChanges')}
            </Button>

            <Button variant="contained" color="primary" onClick={onSave}>
              {t('form:saveFormChanges')}
            </Button>
          </Box>
        </ModalCard.Action>
      </ModalCard>
    </Dialog>
  );
};

export default SaveFormChangesModal;
